export { OriginalPassiveAmountInput } from './original-passive';
